<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/1 xl:w-1/1 mb-base">
      <vs-card>
        <div slot="header">
          <h3>{{ clauseValidDetections.length ? `Tabela wykrytych klauzul` : `W tej umowie nie odnaleziono nielegalnych zapisów`}}</h3>
        </div>

        <vs-table stripe :data="clauseValidDetections" v-if="clauseValidDetections.length">
          <template slot="thead">
            <vs-th>
              Klauzula
            </vs-th>
            <vs-th>
              Strona
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="clause.id" v-for="clause in data" >
              <vs-td>
                {{clause.text}}
              </vs-td>

              <vs-td>
                <span :key="index" v-for="(detection, index) in clause.res">
                  <vs-button color="primary" type="border" v-scroll-to="`#page-${detection.start_page}`">
                  {{detection.start_page === detection.end_page ? detection.start_page : `${detection.start_page}-${detection.end_page}`}}
                  </vs-button>
                </span>
              </vs-td>

            </vs-tr>
          </template>


        </vs-table>

      </vs-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DetectedClauses",
    props: {
      clauseDetections: {
        type: Array,
        required: true
      }
    },
    computed: {
      clauseValidDetections() {
        const clauses = this.clauseDetections.filter(c => c.res.length);
        clauses.sort((a,b) => a.res[0].start_page - b.res[0].start_page);
        return clauses;
      }
    }
  }
</script>

<style scoped>

</style>
